import React from 'react';
import FAQ from '../pages/client/FAQ';
import HomePage from '../pages/HomePage';
import Login from '../pages/client/Login';
// import About from '../pages/client/About';
import SignUp from '../pages/client/SignUp';
import Career from '../pages/client/Career';
import Fractional from '../pages/Fractional';
import Contact from '../pages/client/Contact';
import BookNow from '../pages/client/BookNow';
import InnerSculpt from '../pages/InnerSculpt';
import OurStory from '../pages/client/OurStory';
import { Route, Routes, useLocation } from "react-router-dom";
// import ProductPages from '../pages/product/ProductPages';
// import ProductList from '../pages/product/ProductList';
// import Shop from '../pages/product/Shop';
import Exomind from '../pages/mind/Exomind';
import BlogList from '../pages/blog/BlogList';
import PageNotFound from '../pages/PageNotFound';
import EssenceofTwo from '../pages/EssenceofTwo';
import TheRINURitual from '../pages/TheRINURitual';
import BlogContent from '../pages/blog/BlogContent';
import TheDeepRewire from '../pages/TheDeepRewire';
import WombAndWhisper from '../pages/WombAndWhisper';
import AnimatedLayout from '../layout/AnimatedLayout';
import DMKSkinRevision from '../pages/DMKSkinRevision';
import HybridLaserGlass from '../pages/HybridLaserGlass';
import HybridLaserSerum from '../pages/HybridLaserSerum';
import StretchAndSpirit from '../pages/StretchAndSpirit';
import LaserHairRemoval from '../pages/LaserHairRemoval';
import ElementalAlchemy from '../pages/ElementalAlchemy';
import ResultGallery from '../pages/client/ResultGallery';
import PrivacyPolicy from '../pages/client/PrivacyPolicy';
import StillstoneRelease from '../pages/StillstoneRelease';
import MinorLesionRemoval from '../pages/MinorLesionRemoval';
import ForgotPassword from '../pages/client/ForgotPassword';
import ManicureAndPedicure from '../pages/ManicureAndPedicure';
import RfCollagenInduction from '../pages/RfCollagenInduction';
import AlmaMoleRemoval from '../pages/skin/alma/AlmaMoleRemoval';
import LuxurySignatureFacials from '../pages/LuxurySignatureFacials';
import EmtoneCelluliteSmoothing from '../pages/EmtoneCelluliteSmoothing';
import ExionRFBodySkinTightening from '../pages/ExionRFBodySkinTightening';
import FemaleIntimateWellnessTwo from '../pages/FemaleIntimateWellnessTwo';
import FemaleIntimateWellnessOne from '../pages/FemaleIntimateWellnessOne';
import ExionFaceApplicator from '../pages/skin/exion/ExionFaceApplicator';
import AlmaLaserLabiaplasty from '../pages/skin/alma/AlmaLaserLabiaplasty';
import TargetedLaserSkinTherapies from '../pages/TargetedLaserSkinTherapies';
import EmfaceFacialMuscleLiftTone from '../pages/EmfaceFacialMuscleLiftTone';
import NeedleFreeRFFaceTightening from '../pages/NeedleFreeRFFaceTightening';
import AlmaMycoticInfections from '../pages/skin/alma/AlmaMycoticInfections';
import AlmaVaginalTightening from '../pages/skin/alma/AlmaVaginalTightening';
import JapaneseRestorativeHeadRitual from '../pages/JapaneseRestorativeHeadRitual';
import ClarityIIRosaceaTreatment from '../pages/skin/clarity/ClarityIIRosaceaTreatment';
import AlmaPostMenopauseConditions from '../pages/skin/alma/AlmaPostMenopauseConditions';
import EmfusionTransDermalInfusionFacial from '../pages/EmfusionTransDermalInfusionFacial';
import ClarityIIVascularTreatments from '../pages/skin/clarity/ClarityIIVascularTreatments';
import ClarityIINailFungusTreatment from '../pages/skin/clarity/ClarityIINailFungusTreatment';
import AlmaPostMenopauseConditionsOne from '../pages/skin/alma/AlmaPostMenopauseConditionsOne';
import EmsculptNEOMuscleBuildAndFatReduction from '../pages/EmsculptNEOMuscleBuildAndFatReduction';
import ClarityIIPigmentationTreatments from '../pages/skin/clarity/ClarityIIPigmentationTreatments';
import EmsculptNEOMuscleBuildAndFatReductionOne from '../pages/EmsculptNEOMuscleBuildAndFatReductionOne';
import ExomindNeuromagneticBrainWellnessProgram from '../pages/ExomindNeuromagneticBrainWellnessProgram';
import ClarityIILaserGenesisStyleRejuvenation from '../pages/skin/clarity/ClarityIILaserGenesisStyleRejuvenation';
import NailBar from '../pages/NailBar';
import ExionClearRf from '../pages/ExionClearRf';
import FaceDecolate from '../pages/body/Face_Decolate';

export default function Router() {

    const { pathname } = useLocation();

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <Routes>
            {/* <Route element={<AnimatedLayout />}> */}
                {/* <Route path='/' element={<SignUpTemp />} /> */}
                <Route path='/' element={<HomePage />} />
                {/* Skin Start */}
                <Route path='skin/exion-clear-rf' element={<ExionClearRf />} />
                <Route path='skin/fractional-co2-resurfacing' element={<Fractional />} />
                <Route path='skin/hybrid-laser-erbium-glass' element={<HybridLaserGlass />} />
                <Route path='skin/hybrid-laser-serum-infusion' element={<HybridLaserSerum />} />
                <Route path='skin/rf-collagen-induction' element={<RfCollagenInduction />} />
                <Route path='skin/needle-free-rf-face-tightening' element={<NeedleFreeRFFaceTightening />} />
                <Route path='skin/emfusion-trans-dermal-infusion-facial' element={<EmfusionTransDermalInfusionFacial />} />
                <Route path='skin/emface-facial-muscle-lift-tone' element={<EmfaceFacialMuscleLiftTone />} />
                <Route path='skin/targeted-laser-skin-therapies' element={<TargetedLaserSkinTherapies />} />
                <Route path='skin/exion-face-applicator' element={<ExionFaceApplicator />} />
                <Route path='skin/dmk-skin-revision' element={<DMKSkinRevision />} />
                <Route path='skin/luxury-signature-facials' element={<LuxurySignatureFacials />} />
                <Route path='skin/minor-lesion-removal' element={<MinorLesionRemoval />} />

                <Route path='skin/clarity/clarity-ii-vascular-treatments' element={<ClarityIIVascularTreatments />} />
                <Route path='skin/clarity/clarity-ii-rosacea-treatment' element={<ClarityIIRosaceaTreatment />} />
                <Route path='skin/clarity/clarity-ii-pigmentation-treatments' element={<ClarityIIPigmentationTreatments />} />
                <Route path='skin/clarity/clarity-ii-laser-genesis–style-rejuvenation' element={<ClarityIILaserGenesisStyleRejuvenation />} />
                <Route path='skin/clarity/clarity-ii-nail-fungus-treatment' element={<ClarityIINailFungusTreatment />} />

                <Route path='skin/alma/AlmaMoleRemoval' element={<AlmaMoleRemoval />} />
                <Route path='skin/alma/AlmaVaginalTightening' element={<AlmaVaginalTightening />} />
                <Route path='skin/alma/AlmaMycoticInfections' element={<AlmaMycoticInfections />} />
                <Route path='skin/alma/AlmaPostMenopauseConditions' element={<AlmaPostMenopauseConditions />} />
                <Route path='skin/alma/AlmaPostMenopauseConditionsOne' element={<AlmaPostMenopauseConditionsOne />} />
                <Route path='skin/alma/AlmaLaserLabiaplasty' element={<AlmaLaserLabiaplasty />} />
                {/* Skin End */}

                {/* Body Start */}
                <Route path='body/emsculpt-neo-muscle-build-and-fat-reduction' element={<EmsculptNEOMuscleBuildAndFatReduction />} />
                <Route path='body/exion-rf-body-skin-tightening' element={<ExionRFBodySkinTightening />} />
                <Route path='body/emtone-cellulite-smoothing' element={<EmtoneCelluliteSmoothing />} />
                <Route path='body/female-intimate-wellness-two' element={<FemaleIntimateWellnessTwo />} />
                <Route path='body/female-intimate-wellness-one' element={<FemaleIntimateWellnessOne />} />
                <Route path='body/emsculpt-neo-muscle-build-and-fat-reduction-one' element={<EmsculptNEOMuscleBuildAndFatReductionOne />} />
                <Route path='body/laser-hair-removal' element={<LaserHairRemoval />} />
                <Route path='body/manicure-and-pedicure' element={<ManicureAndPedicure />} />
                <Route path='body/exomind-neuromagnetic-brain-wellness-program' element={<ExomindNeuromagneticBrainWellnessProgram />} />
                {/* Body End */}

                {/* Mind Start */}
                <Route path='mind/exomind' element={<Exomind />} />
                {/* Mind End */}

                {/* Massage Start */}
                <Route path='the-rinu-ritual' element={<TheRINURitual />} />
                <Route path='elemental-alchemy' element={<ElementalAlchemy />} />
                <Route path='still-stone-release' element={<StillstoneRelease />} />
                <Route path='inner-sculpt' element={<InnerSculpt />} />
                <Route path='the-deep-rewire' element={<TheDeepRewire />} />
                <Route path='stretch-and-spirit' element={<StretchAndSpirit />} />
                <Route path='essence-of-two' element={<EssenceofTwo />} />
                <Route path='womb-and-whisper' element={<WombAndWhisper />} />
                <Route path='japanese-restorative-head-ritual' element={<JapaneseRestorativeHeadRitual />} />
                <Route path='face-decollete' element={<FaceDecolate />} />
                {/* Massage End */}

                <Route path='login' element={<Login />} />
                <Route path='signup' element={<SignUp />} />
                <Route path='forgotpassword' element={<ForgotPassword />} />

                <Route path='booknow' element={<BookNow />} />
                <Route path='nail-bar' element={<NailBar />} />
                {/* <Route path='shop' element={<Shop />} /> */}
                {/* <Route path='product/:id' element={<ProductPages />} /> */}

                {/* <Route path='about' element={<About />} /> */}
                <Route path='contact' element={<Contact />} />
                {/* <Route path='careers' element={<Career />} /> */}
                <Route path='faq' element={<FAQ />} />
                <Route path='results-gallery' element={<ResultGallery />} />
                <Route path='our-story' element={<OurStory />} />
                <Route path='policy' element={<PrivacyPolicy />} />
                <Route path='blogs' element={<BlogList />} />
                <Route path="/blogs/:id" element={<BlogContent />} />
                {/* <Route path="/nail-bar" element={<BlogContent />} /> */}
                <Route path="*" element={<PageNotFound />} />
            {/* </Route> */}
        </Routes>
    )
};